<template>
  <div>
    <div class="details-flex">
      <div class="ibox ibox-flex">
        <div class="ibox-content ibox-content-padding-xs">
          <ul class="invoice-details">
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">To:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>
                  {{ paymentDecorated.carrier_name }}<br />
                  {{ paymentDecorated.carrier_address }}<br />
                  {{ paymentDecorated.carrier_suburb }}, {{ paymentDecorated.carrier_state }}, {{ paymentDecorated.carrier_postcode }},<br />
                  Australia
                </p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Payment:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ paymentDecorated.xero_number }}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">ABN:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ paymentDecorated.carrier_abn}}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Issued:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ paymentDecorated.created_date_alternative }}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Paid On:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ paymentDecorated.paid_date_alternative }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="ibox ibox-flex">
        <div class="ibox-content ibox-content-padding-xs">
          <ul class="invoice-details">
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">From:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>
                  Arrow Logistics (QLD) Pty Ltd<br />
                  ATF Forster &amp; Borrman Trust<br />
                  PO Box 4796<br />
                  Toowoomba East QLD 4350<br />
                </p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">ACN:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>119 008 454</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Office:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>0455 123 172</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <upload-invoice></upload-invoice>

    <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs">
        <h3 class="invoice-single">Payment Items</h3>

        <ul class="list-detail list-detail-invoice-single">
          <payment-item v-for="(item, index) in items" :key="index" :item="item"></payment-item>
        </ul>

        <div class="row">
          <div class="col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4">
            <ul class="invoice-totals">
              <li>
                Subtotal
                <span class="amount">{{ paymentDecorated.total_without_gst }}</span>
              </li>
              <li>
                Total GST (10%)
                <span class="amount">{{ paymentDecorated.total_gst }}</span>
              </li>
              <li class="total">
                Total AUD
                <span class="amount">{{ paymentDecorated.total_with_gst }}</span>
              </li>
              <li v-if="paymentDecorated.hasSomePayments">
                Payments
                <span class="amount">{{ paymentDecorated.paid }}</span>
              </li>
              <li class="total" v-if="paymentDecorated.hasSomePayments">
                Amount Due AUD
                <span class="amount">{{ paymentDecorated.remaining }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <ladda-button
              :on-click="handleSyncToXero"
              class="btn btn-sm btn-warning pull-right"
              style="margin-right: 20px;"
            >Sync To Xero</ladda-button>
          </div>
        </div>
      </div>
    </div>

    <div class="margin-20"></div>
  </div>
</template>
<script>
  import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
  import { RESET_PAYMENT } from 'vx/mutations'
  import { chain, filter } from 'lodash'
  import PaymentItem from './ShowPaymentItem'
  import UploadInvoice from './ShowUploadInvoice'
  import { notify } from 'utils'
  import { LaddaButton } from 'components/forms'

  export default {
    components: {
      LaddaButton,
      PaymentItem,
      UploadInvoice
    },

    created () {
      this[RESET_PAYMENT]()

      this.getPayment(this.$route.params.id)
    },

    computed: {
      ...mapGetters('payment', ['paymentDecorated']),
      ...mapState('payment', ['payment']),

      items () {
        return chain(this.payment.items)
          .filter({ type: 'load' })
          .each(item => {
            item.charges = filter(this.payment.items, charge => {
              return charge.type !== 'load' && charge.load_id === item.load_id
            })
          })
          .value()
      }
    },

    methods: {
      ...mapActions('payment', ['getPayment', 'syncPayment']),
      ...mapMutations('payment', [RESET_PAYMENT]),

      handleSyncToXero () {
        return this.syncPayment(this.payment.id)
          .then(() => {
            notify.success('Payment will be synced to Xero soon.')
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?31ce0306